import { faCommentDots } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";

import { Tooltip } from "@aviary";
import { isDevelopment, isStaging } from "@shared/utils";

import * as styles from "./SolvvyChatIcon.styles";

/**
 * This is a placeholder meant to mirror the solvvy chat icon that appears on production.
 * It is meant to help us remember it is there and develop new features around it.
 */
const SolvvyChatIcon: FC = () => {
  if (!(isDevelopment() || isStaging())) return null;

  return (
    <div id="solvvy-v5-widget-container" css={styles.tooltipWrapper}>
      <Tooltip tooltipContent="This is a UI preview and only appears on dev/review/staging.">
        <div css={styles.circle}>
          <FontAwesomeIcon icon={faCommentDots} css={styles.icon} />
        </div>
      </Tooltip>
    </div>
  );
};

export { SolvvyChatIcon };
